import React from 'react';
import { AlgorandAccountResponse } from '../../Model/contact';
import { useTranslation } from 'react-i18next';
import TableView from '../tableView';

interface Props {
  accounts: AlgorandAccountResponse[],
  tabulator: any,
  filterSelectOptions: {},
  formatDate: (value: any) => void
}

const AccountTable = ({
  filterSelectOptions,
  accounts,
  tabulator,
  formatDate
}: Props) => {
  const { t } = useTranslation();
  const accountColumns = [
    {
      title: t('ACCOUNT'),
      field: 'account',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions
    },
    {
      title: t('CREATED_DATE'),
      field: 'createdDate',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions,
      formatter: (cell: any) => formatDate(cell.getValue())
    }
  ];


  return <> {
    accounts.length > 0
      ? <TableView
        t={t}
        ref={tabulator}
        data={accounts}
        columns={accountColumns}
        id={'accounts-list'} />
      : <p className='noData'>{t('NO_DATA')}</p>
  }
  </>;
};

export default AccountTable;